// eslint-disable-next-line no-unused-vars
import { h, Component } from 'preact';
import PropType from 'prop-types';

import {
  assetResolver,
} from '../../utils';

import {
  ButtonContainer,
  ButtonText,
  ButtonIcon,
} from './styles';

const ExploreSubMenuButton = ({
  open, onClick, alternate, buttonLabel, openButtonLabel,
}) => (
  <ButtonContainer
    role="button"
    aria-haspopup="menu"
    alternate={alternate}
    aria-expanded={open}
    open={open}
    aria-controls="nav-explore-submenu"
    onClick={onClick}
  >
    <ButtonText>{open ? openButtonLabel : buttonLabel}</ButtonText>
    <ButtonIcon src={assetResolver(alternate ? 'down-arrow-dark.svg' : 'down-arrow.svg')} alt="Menu" />
  </ButtonContainer>
);

ExploreSubMenuButton.propTypes = {
  buttonLabel: PropType.string.isRequired,
  openButtonLabel: PropType.string.isRequired,
  open: PropType.bool,
  alternate: PropType.bool,
  onClick: PropType.func,
};

ExploreSubMenuButton.defaultProps = {
  open: false,
  alternate: false,
  onClick: () => undefined,
};

export default ExploreSubMenuButton;
